import { render, staticRenderFns } from "./OpenCloseIssues.vue?vue&type=template&id=1f0dde5c&scoped=true"
import script from "./OpenCloseIssues.vue?vue&type=script&lang=js"
export * from "./OpenCloseIssues.vue?vue&type=script&lang=js"
import style0 from "./OpenCloseIssues.vue?vue&type=style&index=0&id=1f0dde5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_prettier@2.8.8_vue-te_c4a30a065520cf149aadd974117fd210/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0dde5c",
  null
  
)

export default component.exports